import service from '@/store/services/employers/work-items-service';

const state = {
    list: {},
    workItem: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, workItem) => {
        state.workItem = workItem;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(workItem => {
                commit('SET_RESOURCE', workItem);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(workItem => {
                commit('SET_RESOURCE', workItem);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((workItem) => {
                commit('SET_RESOURCE', workItem);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((workItem) => {
                commit('SET_RESOURCE', workItem);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    saveTicket({ commit }, params) {
        return service.saveTicket(params);
    },
    previewTicket({ commit }, params) {
        return service.previewTicket(params);
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    workItem: state => state.workItem,
    dropdown: (state) => {
        return state.list.map(workItem => ({
            id: workItem.id,
            name: workItem.name
        }));
    }
};

const workItems = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default workItems;
